import { render, staticRenderFns } from "./StandardsList.vue?vue&type=template&id=005aee68&scoped=true"
import script from "./StandardsList.vue?vue&type=script&lang=ts"
export * from "./StandardsList.vue?vue&type=script&lang=ts"
import style0 from "./StandardsList.vue?vue&type=style&index=0&id=005aee68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005aee68",
  null
  
)

export default component.exports